import { Injectable } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { Subject } from 'rxjs';
import { Chat } from 'src/app/shared/models/chat/chat';
import { SearchParams } from 'src/app/shared/models/searchParams';
import { ChatApiService } from './api/chat-api.service';

@Injectable({
  providedIn: 'root'
})
export class ChatService {
  public searchParams: SearchParams = new SearchParams();
  activeChat$: Subject<Chat> = new Subject<Chat>();
  chats$: Subject<Chat[]> = new Subject<Chat[]>();
  chatList: Chat[] = [];
  destroyed$ = new Subject();
  chatCount = 0;


  constructor(
    private spinner: NgxSpinnerService,
    private chatApi: ChatApiService,
    private route: ActivatedRoute,

  ) {
    // this.loadChats(this.searchParams);
  }

  loadChats(searchParams: SearchParams) {
    this.spinner.show();
    this.chatApi.getChats(searchParams).subscribe(
      r => {
        this.chatList = this.chatList.concat(r.results);
        this.chatCount = r.count;
        this.chats$.next(this.chatList);
        this.activeChat$.next(Object.assign(new Chat(), r.results.find((c, i, arr) => {
          return c.uuid === this.route.root.firstChild?.firstChild?.firstChild?.firstChild?.snapshot.params.uuid;
        })))
        this.spinner.hide();
      }
    )
  }

  updateChatList(searchParams: SearchParams) {
    this.chatApi.getChats(searchParams).subscribe(
      r => {
        this.chatList = [...r.results];
        this.chats$.next(this.chatList);
        this.chatCount = r.count
      }
    )
  }

  reset() {
    this.searchParams = new SearchParams();
    this.activeChat$ = new Subject<Chat>();
    this.chats$ = new Subject<Chat[]>();
    this.chatList = [];
    this.destroyed$ = new Subject();
    this.chatCount = 0;
  }
}
